import axiosInstance from "../axiosInstance";

export const getDashboardData = async () => {
  try {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const token = userData?.token;

    const response = await axiosInstance.get("/get_partner_data", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching services data", error);
    throw error;
  }
};
